/**
 *
 * OveitIcon
 *
 */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Arrow } from './../../../assets/icons/arrow.svg';
import { ReactComponent as Back } from './../../../assets/icons/back.svg';
import { ReactComponent as Calendar } from './../../../assets/icons/calendar.svg';
import { ReactComponent as Like } from './../../../assets/icons/like.svg';
import { ReactComponent as Pin } from './../../../assets/icons/pin.svg';
import { ReactComponent as Share } from './../../../assets/icons/share.svg';
import { ReactComponent as SolidGreenCheck } from './../../../assets/icons/solid-green-check.svg';
import { ReactComponent as SolidWhiteCheck } from './../../../assets/icons/solid-white-check.svg';
import { ReactComponent as Close } from './../../../assets/icons/close.svg';
import { ReactComponent as Ticket } from './../../../assets/icons/ticket.svg';
import { ReactComponent as ArrowDropDown } from './../../../assets/icons/arrow-drop-down.svg';
import { ReactComponent as ChevronRight } from './../../../assets/icons/chevron-right.svg';
import { ReactComponent as ChevronDown } from './../../../assets/icons/chevron-down.svg';
import { ReactComponent as Minus } from './../../../assets/icons/minus.svg';
import { ReactComponent as Plus } from './../../../assets/icons/plus.svg';
import { ReactComponent as OpenEye } from './../../../assets/icons/open-eye.svg';
import { ReactComponent as Email } from './../../../assets/icons/email.svg';
import { ReactComponent as Invoice } from './../../../assets/icons/invoice.svg';
import { ReactComponent as Download } from './../../../assets/icons/download.svg';
import { ReactComponent as User } from './../../../assets/icons/user.svg';
import { ReactComponent as Clock } from './../../../assets/icons/clock.svg';
import { ReactComponent as Voucher } from './../../../assets/icons/voucher.svg';
import { ReactComponent as AlertTriangle } from './../../../assets/icons/alert-triangle.svg';
import { ReactComponent as Sparkle } from './../../../assets/icons/sparkle.svg';

export type OveitIconType =
  | 'like'
  | 'share'
  | 'pin'
  | 'calendar'
  | 'ticket'
  | 'back'
  | 'arrow'
  | 'solidGreenCheck'
  | 'solidWhiteCheck'
  | 'close'
  | 'arrowDropDown'
  | 'chevronRight'
  | 'chevronDown'
  | 'minus'
  | 'plus'
  | 'openEye'
  | 'email'
  | 'invoice'
  | 'download'
  | 'user'
  | 'clock'
  | 'voucher'
  | 'alertTriangle'
  | 'sparkle';

interface Props {
  className?: string;
  size?: number;
  fill?: string;
  name: OveitIconType;
}

const Icons: object = {
  like: Like,
  share: Share,
  pin: Pin,
  calendar: Calendar,
  ticket: Ticket,
  back: Back,
  arrow: Arrow,
  solidGreenCheck: SolidGreenCheck,
  solidWhiteCheck: SolidWhiteCheck,
  close: Close,
  arrowDropDown: ArrowDropDown,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  minus: Minus,
  plus: Plus,
  openEye: OpenEye,
  email: Email,
  invoice: Invoice,
  download: Download,
  user: User,
  clock: Clock,
  voucher: Voucher,
  alertTriangle: AlertTriangle,
  sparkle: Sparkle,
};

export function OveitIcon(props: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const TagName = Icons[props.name || ''];
  // const Fill = props.fill || '#000';
  const Size = props.size || 16;
  const ClassName = 'oveit-icon ' + (props.className || '');

  return <TagName width={Size} height={Size} className={ClassName} />;
}
